import type { FeatureReferenceBinding } from '../../binding/FeatureReferenceBinding';
import type { FeatureDefinition } from '../../definition/FeatureDefinition';
import type { FeatureEditSession } from '../../edit/FeatureEditSession';
import type { FeaturePrototype } from '../../prototype/FeaturePrototype';

/**
 * 特征提交执行输入。
 */
export interface FeatureCommitExecutionInput {
    /** 特征种类。 */
    featureKind: string;
    /** 编辑态特征 ID。 */
    featureId?: string | null;
    /** 提交定义。 */
    definition: FeatureDefinition;
    /** 已解析的输入绑定。 */
    bindings: FeatureReferenceBinding[];
    /** 当前编辑会话。 */
    session: FeatureEditSession | null;
}

/**
 * 特征提交执行结果。
 */
export interface FeatureCommitExecutionResult {
    /** 是否替换既有特征。 */
    replaced: boolean;
    /** 特征 ID。 */
    featureId: string;
    /** 对应特征原型。 */
    prototype: FeaturePrototype;
    /** 新建时返回的 mesh 数据。 */
    meshData: MeshData | null;
    /** 新建时生成的对象 ID。 */
    objectId?: string;
    /** 新建时生成的全部对象 ID。 */
    objectIds?: string[];
    /** 新建时返回的全部 mesh 数据。 */
    meshDataList?: MeshData[];
}

/**
 * 特征提交执行处理器抽象基类。
 */
export abstract class FeatureCommitExecutionHandler {
    /**
     * 判断是否支持当前提交输入。
     *
     * @param input 提交输入。
     * @returns 是否支持。
     */
    public abstract supports(input: FeatureCommitExecutionInput): boolean;

    /**
     * 执行特征提交。
     *
     * @param input 提交输入。
     * @returns 提交结果。
     */
    public abstract execute(input: FeatureCommitExecutionInput): Promise<FeatureCommitExecutionResult>;
}
